import { notificationsProgrammingReducer } from './services/notifications.service';

export const QUICKSTART_NOTIFICATIONS_REDUCERS = {
  notificationsProgramming: notificationsProgrammingReducer
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-notifications/notifications.store.ts